import { Component, OnInit } from '@angular/core';
import { EnterpriseService } from './enterprise.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CanonicalService } from 'src/app/shared/services/canonical.service';
import { PosthogService } from 'src/app/shared/services/posthog.service';
import { CommonUsecaseHeroComponent } from 'src/app/shared/components/sub-products/usecase-hero/hero.component';
import { CommonCompaniesPanelComponent } from 'src/app/shared/components/companies-panel/companies-panel.component';
import { CommonSubProductsAlternateBlocksComponent } from 'src/app/shared/components/sub-products/alternate-blocks/alternate-blocks.component';
import { EnterpriseCaseStudyComponent } from './case-study/case-study.component';
import { EnterpriseOtherFeaturesComponent } from './other-features/other-features.component';
import { CommonSubProductsWhitePaperComponent } from 'src/app/shared/components/sub-products/white-paper/white-paper.component';
import { EnterpriseHelpingBusinessComponent } from './helping-business/helping-business.component';
import { EnterpriseApiContentComponent } from './api-content/api-content.component';
import { CommonGetstartedComponent } from 'src/app/shared/components/getstarted/getstarted.component';

@Component({
  selector: 'app-enterprise',
  templateUrl: './enterprise.component.html',
  styleUrls: ['./enterprise.component.scss'],
  imports: [
    CommonUsecaseHeroComponent,
    CommonCompaniesPanelComponent,
    CommonSubProductsAlternateBlocksComponent,
    EnterpriseCaseStudyComponent,
    EnterpriseOtherFeaturesComponent,
    CommonSubProductsWhitePaperComponent,
    EnterpriseHelpingBusinessComponent,
    EnterpriseApiContentComponent,
    CommonGetstartedComponent,
  ],
})
export class EnterpriseComponent implements OnInit {
  heroHeader:any;
  logosData:any;
  featureData1:any;
  featureData2:any;
  getStartedData:any;
  whitePaperData:any;
  constructor(
    private enterpriseService: EnterpriseService,
    private meta: MetaService,
    private route: ActivatedRoute,
    private canonical: CanonicalService,
    private router: Router,
    private posthog: PosthogService
  ) {
    this.getUrl = this.router.url;
  }

  getUrl: any;
  metaBody = {
    title: '',
    description: '',
    url: '',
    image: '',
    type: '',
  };
  ngOnInit(): void {
    this.posthog.capturePageViewEvent('enterprises');
    this.enterpriseService.getEnterprisePageData();
    this.meta.updateMeta(
      this.route.snapshot.data?.['seo']?.[0]?.fields?.seoMetadataReference
        ?.fields
    );
    this.canonical.setCanonicalURL();
    let data = this.route.snapshot.data?.['seo']?.[0].fields;
    this.metaBody.title = data?.seoMetadataReference?.fields.title || 'Verto: Cross-border payments platform for businesses';
    this.metaBody.description = data?.seoMetadataReference?.fields.description || 'Verto: Cross-border payments platform for businesses across the globe.';
    this.metaBody.type = 'Stage: Enterprise';
    this.metaBody.url = this.getUrl;
    this.metaBody.image = data?.heroContentPanel?.fields?.image[0]?.fields?.file?.url;
    this.meta.updateOG(this.metaBody);

    // fetch Hero Data
    this.enterpriseService.scaleupHero$.subscribe(data => {
      if (data != null) {
        this.heroHeader = {
          tagName: data?.components?.[0]?.fields?.tagText,
          header: data.title,
          image: data.image[0].fields,
          paragraph: data.content,
          button1: {
            text: data?.buttons?.[0]?.fields.buttonText,
            url: data?.buttons?.[0]?.fields.redirectLink,
            target: data?.buttons?.[0]?.fields.actionType,
          },
          button2: {
            text: data?.buttons?.[1]?.fields.buttonText,
            url: data?.buttons?.[1]?.fields.redirectLink,
            target: data?.buttons?.[1]?.fields.actionType,
          },
        };
      }
    });
    // fetch logos data
    this.enterpriseService.scaleupCustomerStats$.subscribe(data => {
      if (data != null) {
        let imgData = data.image;
        this.logosData = imgData.map((x:any) => x?.fields?.file?.url);
      }
    });
    this.enterpriseService.scaleupFeaturePanel1$.subscribe(data => {
      if (data != null) {
        this.featureData1 = data;
      }
    });
    this.enterpriseService.scaleupWhitePaperPanel$.subscribe(data => {
      if (data != null) {
        this.whitePaperData = data;
      }
    });
    this.enterpriseService.getStarted$.subscribe(data => {
      if (data != null) {
        this.getStartedData = {
          header: data.title,
          button1: {
            url: data?.buttons?.[0]?.fields.redirectLink,
            text: data?.buttons?.[0]?.fields.buttonText,
            target: data?.buttons?.[0]?.fields.actionType,
          },
          button2: {
            url: data?.buttons?.[1]?.fields.redirectLink,
            text: data?.buttons?.[1]?.fields.buttonText,
            target: data?.buttons?.[1]?.fields.actionType,
          },
        };
      }
    });
  }
}
